const PP_URLS = [
  'success',
  'fail',
  '404',
  'denied',
  'entercard',
  'secure',
  'paid',
  'failed',
  'rejected',
];

export const isNotPPRouteUrls = value => !PP_URLS.find(routeName => routeName === value);

// eslint-disable-next-line no-useless-escape
const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const isEmail = value => {
  return EMAIL_REGEX.test(String(value).toLowerCase());
};

// eslint-disable-next-line no-useless-escape
const PHONE_REGEX = /^[\+|\d][\d|\(|\)|\s|\-]+$/g;

export const isPhone = value => {
  if (!value) {
    return true;
  }

  return PHONE_REGEX.test(String(value).toLowerCase());
};

// eslint-disable-next-line no-useless-escape
const URL_REGEX = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/gi;

export const isUrl = value => {
  return URL_REGEX.test(String(value));
};

export const isEmailOrPhone = value => isEmail(value) || isPhone(value);

export const empty = value => value.length;

export const isMoreMinAmount = (minAmount, currency) => value => {
  if (!value) return true;

  let result = Number(value.deleteSpaces());
  result = result * 10 ** currency.significant_zeros;

  return result >= minAmount;
};

export const isLessMaxAmount = (maxAmount, commission, currency) => value => {
  if (!value) return true;

  let result = Number(value.deleteSpaces());
  result = result * 10 ** currency.significant_zeros;

  return result + commission <= maxAmount;
};
